import { useMutation, useQueryClient } from '@tanstack/react-query';
import { changeCustomerName } from '../services/customers';
import type { ChangeCustomerNameInput } from '../types/customers.types';
import { customerKeys } from './customerKeys';

/** Deliberately not optimistic: a legal name on a live contract is shown only
 *  once the server holds it. */
export function useChangeCustomerNameMutation(id: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: ChangeCustomerNameInput) => changeCustomerName(id, input),
        // customer_snapshot is immutable by design, so no agreementKeys prefix
        // is invalidated.
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: customerKeys.detail(id) });
            void queryClient.invalidateQueries({ queryKey: customerKeys.amendments(id) });
        },
    });
}
